<figure style="overflow:visible;" id="qtspinner2">
    <img src="https://eprint.ink/files/wasm/qtlogo.svg" width="320" height="200" style="display:block">
    <strong>Qt for WebAssembly: magicpdf</strong>
    <div id="qtstatus2"></div>
    <noscript>JavaScript is disabled. Please enable JavaScript to use this application.</noscript>
</figure>
<div id="screen2"></div>